import {
  Button,
  createTheme,
  CSSVariablesResolver,
  DrawerOverlay,
  Input,
  InputBase,
  MantineTheme,
  PasswordInput,
  PillsInput,
  rem,
  rgba,
  Stepper,
  TextInput,
  ThemeIcon,
} from '@mantine/core';
import { DatePickerInput } from '@mantine/dates';

export const theme = createTheme({
  fontFamily: 'Geist, sans-serif',
  headings: {
    sizes: {
      h1: {
        fontSize: rem(40),
        lineHeight: rem(48),
        fontWeight: '600',
      },
      h2: {
        fontSize: rem(32),
        lineHeight: rem(40),
        fontWeight: '600',
      },
      h4: {
        fontWeight: '600',
        fontSize: rem(20),
        lineHeight: rem(24),
      },
      h3: {
        fontSize: rem(24),
        lineHeight: rem(32),
        fontWeight: '600',
      },
      h5: {
        fontWeight: '600',
        fontSize: rem(16),
        lineHeight: rem(20),
      },
    },
  },
  primaryColor: 'indigo',
  // todo перевести на rem и в scss тоже
  breakpoints: {
    xs: '375px',
    sm: '767px',
    md: '1024px',
    lg: '1440px',
    xl: '1920px',
  },
  // Дополнительные отступы
  spacing: {
    xxs: rem(8),
    xxxs: rem(4),
    xxxxs: rem(2),
    xxl: rem(24),
  },
  radius: {
    xs: rem(3), // 3px
    sm: rem(6), // 6px
    md: rem(10), // 10px
    lg: rem(16), // 16px
    xl: rem(24), // 24px
  },
  cursorType: 'pointer',
  components: {
    ThemeIcon: ThemeIcon.extend({
      vars: (_, { size }) => {
        if (size === 'xl') {
          return {
            root: {
              '--ti-size': rem(56),
            },
          };
        }

        return { root: {} };
      },
    }),
    TextInput: TextInput.extend({
      vars: (_, { label }) => {
        return {
          wrapper: {
            '--input-margin-top': label ? rem(4) : 0,
            '--input-margin-bottom': rem(0),
          },
        };
      },
    }),
    PasswordInput: PasswordInput.extend({
      vars: (_, { label }) => {
        return {
          root: {},
          wrapper: {
            '--input-margin-top': label ? rem(4) : 0,
            '--input-margin-bottom': rem(0),
          },
        };
      },
    }),
    Input: Input.extend({
      vars: (_, props) => {
        return {
          wrapper: {
            '--input-margin-top': 'label' in props ? rem(4) : rem(0),
            '--input-margin-bottom': rem(0),
          },
        };
      },
    }),
    InputBase: InputBase.extend({
      vars: (_, { label }) => {
        return {
          wrapper: {
            '--input-margin-top': label ? rem(4) : 0,
            '--input-margin-bottom': rem(0),
          },
        };
      },
    }),
    PillsInput: PillsInput.extend({
      vars: (_, { label }) => {
        return {
          wrapper: {
            '--input-margin-top': label ? rem(4) : 0,
            '--input-margin-bottom': rem(0),
          },
        };
      },
    }),
    Button: Button.extend({
      defaultProps: {
        size: 'lg',
      },
      vars: (_, { size }) => {
        if (size === 'xm') {
          return {
            root: {
              '--button-height': rem(36),
              '--button-padding-x': rem(14),
              '--button-fz': rem(14),
            },
          };
        }

        return { root: {} };
      },
    }),
    Stepper: Stepper.extend({
      vars: (theme) => {
        return {
          root: {
            '--stepper-content-padding': theme.spacing.xl,
          },
        };
      },
    }),
    DatePickerInput: DatePickerInput.extend({
      vars: (_, { label }) => {
        return {
          wrapper: {
            '--input-margin-top': label ? rem(4) : 0,
            '--input-margin-bottom': rem(0),
          },
        };
      },
    }),
    DrawerOverlay: DrawerOverlay.extend({
      defaultProps: {
        color: '#000',
        blur: 5,
        backgroundOpacity: 0.32,
      },
    }),
  },
});

export const cssVariablesResolver: CSSVariablesResolver = (theme: MantineTheme) => {
  return {
    variables: {
      '--mantine-primary-color-ultra-light': rgba(theme.colors[theme.primaryColor][6], 0.05),
      '--mantine-primary-color-light': theme.colors[theme.primaryColor][9],
      '--mantine-color-gray-hover': theme.colors.gray[7],
    },
    dark: {},
    light: {
      '--mantine-color-default-border': theme.colors.gray[2],
    },
  };
};
